module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-east-west-coast/key-1-2020.svg?v=40688eb5";